import * as Yup from "yup";

import applicantsValidation from "./steps/ApplicantDetails/validation";
import employmentValidation from "./steps/ApplicantEmployment/validation";
import expenditureValidation from "./steps/Expenditure/validation";
import brokerValidation from "./steps/BrokerDetails/validation";
import loanValidation from "./steps/Loan/validation";
import otherValidation from "./steps/OtherDetails/validation";
import propertyValidation from "./steps/Property/validation";
import confirmValidation from "./steps/ReviewConfirm/validation";
import productValidation from "./steps/Product/validation";

export const validationSchema: Yup.ObjectSchema<any> = Yup.object({
  numberOfApplicants: Yup.number(),
  broker: brokerValidation,
  applicants: applicantsValidation,
  employments: employmentValidation,
  expenditure: expenditureValidation,
  loan: loanValidation,
  property: propertyValidation,
  other: otherValidation,
  product: productValidation,
  confirm: confirmValidation,
});
